var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"m10 15 5 5 5-5"}}),_c('path',{attrs:{"d":"M4 4h7a4 4 0 0 1 4 4v12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }